export interface ExportacaoContabilDto {
  contasBancarias: {
    id: string;
    codigoIntegracao: string | null;
    nome: string;
  }[];
  despesas: {
    id: string;
    codigoIntegracao: string | null;
    nome: string;
    pessoas: {
      id: string;
      codigoIntegracao: string | null;
      nome: string;
    }[];
    valor: number;
  }[];
  receitas: {
    id: string;
    codigoIntegracao: string | null;
    nome: string;
    pessoas: {
      id: string;
      codigoIntegracao: string | null;
      nome: string;
    }[];
    valor: number;
  }[];
  transferencias: {
    id: string;
    codigoIntegracao: string | null;
    nome: string;
    pessoas: {
      id: string;
      codigoIntegracao: string | null;
      nome: string;
    }[];
    valor: number;
  }[];
}

export interface FiltroExportacaoContabil {
  dataInicio?: string;
  dataFim?: string;
  contasBancariasIds?: string[];
}

export interface ExportacaoContabilForm {
  contasBancarias: {
    id: string;
    codigoIntegracao?: string;
    selected: boolean;
    nome: string;
  }[];
  receitas: FormaRecebimento[];
  despesas: FormaRecebimento[];
  transferencias: ExportacaoContabilDto["transferencias"];
  letraTipo: "todoMaiuscula" | "primeiraMaiuscula";
  incluirDescricaoHistorico: boolean;
}

export interface FormaRecebimento {
  categoriaFinanceiraId: string;
  codigoIntegracao?: string;
  tipoContabilizacao: TipoContabilizacaoEnum;
  pessoas: {
    id: string;
    codigoIntegracao: string;
  }[];
}

export enum TipoContabilizacaoEnum {
  ProvisaoBaixaCliente = "ProvisaoBaixaCliente",
  BaixaCliente = "BaixaCliente",
  BaixaPrevisao = "BaixaPrevisao",
  ProvisaoBaixaFornecedor = "ProvisaoBaixaFornecedor",
  BaixaFornecedor = "BaixaFornecedor",
}
